import Siema from 'siema';

export default function Slider() {
    if (document.querySelector('.slider')) {
        const slider = new Siema({
            selector: '.slider',
            perPage: {
                768: 2,
                1024: 3,
                1200: 4,
            },
            duration: 500,
            loop: true
        })
        setInterval(() => slider.next(), 2000);
    }

}